import { Metric } from '@models';

export const metrics: { [key: string]: Metric } = {
  time: {
    value: 0,
    unit: 'Second',
    id: '87cd8325-7f02-4673-9d8f-b9462331a079',
  },
  leftNeedleDriverPath: {
    value: 0,
    unit: 'Centimeter',
    id: '16be0af3-313b-4c86-b32f-367ca06de015',
  },
  rightNeedleDriverPath: {
    value: 0,
    unit: 'Centimeter',
    id: 'c7612eb5-65a3-4877-94cf-074c6641f633',
  },
};
